import { useQuery } from '@tanstack/react-query';
import classNames from 'classnames';
import { useParams } from 'next/navigation';
import { overlay } from 'overlay-kit';

import BottomSheet from '@/components/common/bottomSheets';
import RealtorCall from '@/components/common/bottomSheets/menulDetail/realtorCall';
import { BUSINESS_DIV_TYPE, BusinessDivKey } from '@/const/buildingType';
import favoriteQueries, { useFavoriteMemul } from '@/service/memul/favoritesUtil';
import queries from '@/service/memul/memulQueries';
import useMobileStore from '@/store/mobileStore';
import { handleSendGAEvent } from '@/utils/google';

export default function MemulDetailBottom() {
  const { articleCd } = useParams();
  const { handleFavoriteClick } = useFavoriteMemul();
  const { data } = useQuery({
    ...queries.memulDetail(articleCd as string),
    select: (data) => data.data,
  });
  const { data: favoriteCount } = useQuery({
    ...favoriteQueries.count({ favorites: 'offering', favorite: articleCd as string }),
    select: (data) => data?.data?.items?.count,
  });

  const { isMobile, isWebView } = useMobileStore();

  const handleRealtorCall = (articleCd: any) => {
    overlay.open(({ isOpen, close }) => {
      return (
        <BottomSheet isOpen={isOpen} close={close} title="중개사 문의">
          <RealtorCall articleCd={articleCd} />
        </BottomSheet>
      );
    });
  };

  const shouldShowBottomButtons = favoriteCount > 2 || isWebView || isMobile;

  if (!shouldShowBottomButtons) return null;

  return (
    <section className="fixed_bottom_btn">
      {favoriteCount > 2 && (
        <div className="tooltip_div">
          <div className="tooltip popular_memul">
            이 매물에 관심있는 사람 <strong className="text_primary">{favoriteCount}</strong>명!
            <br />
            중개사에게 빨리 연락해보세요~
          </div>
        </div>
      )}
      <div className="group_btn ratio">
        {isWebView && (
          <button
            type="button"
            className={classNames('btn_gray50 btn_favorite', {
              active: data?.memberFavoriteInfo?.[0]?.useYn === 'Y',
            })}
            onClick={() => {
              data?.articleCd &&
                data?.businessDiv &&
                Object.keys(BUSINESS_DIV_TYPE).includes(data?.businessDiv) &&
                handleFavoriteClick({
                  sOfferingSN: data?.articleCd,
                  sOfferType: data?.businessDiv as BusinessDivKey,
                  buildingTypeCd: data?.buildingTypeCd,
                  nScaleCode: data?.ptpCd ?? 0,
                  nComplexCode: data?.danjiCd ?? 0,
                });

              handleSendGAEvent('memul_memul_detail_like_btn', {
                event_category: 'memul',
                memul_id: data?.articleCd,
              });
            }}
          >
            <span className="text_blind">관심 매물</span>
          </button>
        )}
        {isMobile && (
          <button
            type="button"
            className="btn_primary"
            onClick={() => {
              handleRealtorCall(articleCd);
              if (isWebView) {
                handleSendGAEvent('memul_memul_detail_inquiry_btn', {
                  event_category: 'memul',
                  memul_id: data?.articleCd,
                  realtor_id: data?.agencySeq,
                });
              } else {
                handleSendGAEvent('share_memul_inquiry_btn', {
                  event_category: 'share',
                  memul_id: data?.articleCd,
                  realtor_id: data?.agencySeq,
                });
              }
            }}
          >
            중개사 문의
          </button>
        )}
      </div>
    </section>
  );
}
